<script>
import Layout from '../../layouts/main'
import PageHeader from '../../components/page-header'
import AddOrder from './add-order';

export default {
    components: {Layout, PageHeader, AddOrder},
    data() {
        return {
            title: this.trans.get('__JSON__.Add Order'), 
        };
    },
}
</script>

<template>
  <Layout>
    <!-- <PageHeader :title="title"/> -->
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-briefcase"></i>
              </span>
            </div>
             <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ trans.trans('__JSON__.Add Order') }}</h4>
               <p><router-link :to="{ name: 'orders-list'}">{{ trans.get('__JSON__.Orders') }}</router-link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <add-order />
      </div>      
    </div>
  </Layout>
</template>